import api from './axios';

export interface ComprobanteLog {
  id: number;
  ruc: string;
  tipoDocumento: string;
  serie: string;
  numero: string;
  fechaEmision: string;
  moneda: string;
  totalGravada: number;
  totalIgv: number;
  totalPagar: number;
  clienteDocumento: string;
  clienteNombre: string;
  estado: string;
  codigoRespuesta: string;
  mensajeSunat: string;
  hashCdr: string;
  errorDetalle: string;
  nombreArchivo: string;
  modo: number;
  intentos: number;
  requestJson: string;
  createdAt: string;
  updatedAt: string;
}

export const facturacionApi = {
  getLogs: (params?: Record<string, any>) =>
    api.get<{ data: ComprobanteLog[]; total: number }>('/orders/comprobantes/logs', { params }),

  getFallidos: () =>
    api.get<ComprobanteLog[]>('/orders/comprobantes/fallidos'),

  getDetalle: (logId: number) =>
    api.get<ComprobanteLog>(`/orders/comprobantes/${logId}`),

  getImpresion: (logId: number) =>
    api.get(`/orders/comprobantes/${logId}/impresion`, { responseType: 'text' }),

  reenviar: (logId: number) =>
    api.post(`/orders/comprobantes/reenviar/${logId}`),

  editarReenviar: (logId: number, payload: any) =>
    api.post(`/orders/comprobantes/editar-reenviar/${logId}`, payload),

  emitirNotaCredito: (orderId: number, motivo: string, descripcion: string) =>
    api.post(`/orders/${orderId}/nota-credito`, { motivo, descripcion }),
};
